export const enum MutationNames {
  updateWatchLists = 'WATCH_LIST_UPDATE_WATCH_LISTS',
}

export const enum ActionNames {
  getWatchLists = 'WATCH_LIST_GET_WATCH_LISTS',
  postWatchList = 'WATCH_LIST_POST_WATCH_LIST',
  patchWatchList = 'WATCH_LIST_PATCH_WATCH_LIST',
}

export const enum GetterNames {
  watchLists = 'WATCH_LIST_WATCH_LISTS',
  uniqWatchListsByPatient = 'WATCH_LIST_UNIQ_WATCH_LISTS_BY_PATIENT',
  watchingWatchLists = 'WATCH_LIST_WATCHING_WATCH_LISTS',
}
